export const MEDRM_TAG_TYPE = 'MedRM';
